import { useCallback } from "react";
import { useColorScheme } from "@mui/material/styles";

const mediaCache = new Map<string, string>();

// eslint-disable-next-line no-undef
export const importMediaPaths = (requireContextTheme: __WebpackModuleApi.RequireContext, requireContextCore: __WebpackModuleApi.RequireContext) => {
	for (const key of requireContextTheme.keys()) {
		mediaCache.set(key, requireContextTheme(key));
	}
	for (const key of requireContextCore.keys()) {
		if (!mediaCache.has(key)) {
			mediaCache.set(key, requireContextCore(key));
		}
	}
};

/**
 * Get media path helper functions for current theme by theme mode (`light`/`dark`).
 */
export const useMedia = () => {
	const { mode, systemMode } = useColorScheme();

	const themeStyle = ((systemMode ?? mode) === "dark") ? "dark" : "generic";

	const getMediaPath = useCallback((path: string) => {
		// ignore console errors when running tests
		if (process.env.NODE_ENV === "test") {
			return "";
		}

		const fullPath = mediaCache.has(`./${themeStyle}/${path}`) ? `./${themeStyle}/${path}` as const : `./generic/${path}` as const;
		const mediaPath = mediaCache.get(fullPath);
		if (mediaPath === undefined) {
			console.error(`could not find media ${path} (${fullPath})`);
			// throw new Error(`could not find media ${path} (${fullPath})`);
		}
		return mediaPath;
	}, [themeStyle]);

	const hasMediaPath = useCallback((path: string) => (
		mediaCache.has(`./${themeStyle}/${path}`) || mediaCache.has(`./generic/${path}`)
	), [themeStyle]);

	return { getMediaPath, hasMediaPath } as const;
};
